module.exports = {
  pathPrefix: '',
  siteUrl: 'https://home.tech-office-mori.com/',
  siteTitle: 'tech office mori',
  siteDescription: 'Logbook of a material & software developer',
  author: 'tech office mori',
  postsForArchivePage: 3,
  defaultLanguage: 'ja',
  disqusScript: process.env.DISQUS_SCRIPT || 'https://tech-office-mori.disqus.com/embed.js',
  pages: {
    home: 'blog',
    blog: 'blog',
    about: 'about',
    tag: 'tags',
    contact: 'contact'
  },
  social: {
    github: process.env.GITHUB_ACCOUNT || 'https://github.com/hodakamori/',
    linkedin: process.env.LINKEDIN_ACCOUNT || 'https://www.linkedin.com/in/hodaka-mori-146b61ba/',
  },
  skills: {
    django: 'https://www.djangoproject.com/',
    lammps: 'https://www.lammps.org/',
    gromacs :'https://www.gromacs.org/',
    dash:'https://dash.plotly.com/',
    docker: 'https://www.docker.com/',
    python: 'https://www.python.org/',
    gatsby: 'https://www.gatsbyjs.com/',
    react:'https://reactjs.org/',
  },
  contactFormUrl: process.env.CONTACT_FORM_ENDPOINT || 'https://getform.io/f/542b73ce-3338-4929-90c4-a17213741e84',
  googleAnalyticTrackingId: process.env.GA_TRACKING_ID || 'G-MTRB2L4X0C',
  tags: {
    machinelearning: {
      name: 'machinelearning',
      description: 'Machine learning is a computer algorithm or area of research that automatically improves by learning from experience and is considered a type of artificial intelligence.',
      color: '#445675',
    },
    environment: {
      name: 'environment',
      description: 'Build local environments, cloud, and much more.',
      color: '#445675',
    },
    RDkit: {
      name: 'rdkit',
      description: 'RDKit is a collection of cheminformatics and machine-learning software written in C++ and Python.',
      color: '#445675',
    },
    LAMMPS: {
      name: 'LAMMPS',
      description: 'LAMMPS is a classical molecular dynamics code with a focus on materials modeling. It\'s an acronym for Large-scale Atomic/Molecular Massively Parallel Simulator.',
      color: '#445675',
    },
    docker: {
      name: 'docker',
      description: 'Docker is an open platform for developing, deploying and running applications using container virtualization.',
      color: '#445675',
    },
    CP2K: {
      name: 'CP2K',
      description: 'CP2K is a quantum chemistry and solid state physics software package that can perform atomistic simulations.',
      color: '#445675',
    },
    Dash: {
      name: 'Dash',
      description: 'Dash is the original low-code framework for rapidly building data apps in Python, R, Julia, and F# (experimental).',
      color: '#445675',
    },
    Reactjs: {
      name: 'reactjs',
      description: 'React is an open source JavaScript library used for designing user interfaces.',
      color: '#445675',
    },
    Gatsby: {
      name: 'Gatsby.js',
      description: 'A framework built over ReactJS to generate static page web application.  ',
      color: '#445675',
    },
    python: {
      name: 'python',
      description: 'A general purpose programming language that is widely used for developing various applications.',
      color: '#445675',
    },
  },
};
